export const detailsTableLangKey = {
  computed: {
    langTableKey () {
      return 'components.prk_syllabus.table'
    },
  },
}
